import { ISession } from '@ftd/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/api/constants'
import { apiCreateSession } from '@/api/session'
import { QueryConfig } from '@/lib/query-client'

export const useCreateSession = (queryConfig?: QueryConfig<typeof apiCreateSession>) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: Partial<ISession<string>>) => apiCreateSession(data),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SESSIONS],
      }),
    ...queryConfig,
  })
}
